{
  "WHITE_LABEL": "partaki",
  "APP_SCHEME": "partaki",
  "APPLE_APP_ID": "6755892083",
  "CONTACT_EMAIL": "info@we-partake.com",
  "SUPPORTED_LANGUAGES": ["en", "fr", "es"],
  "FEATURE_FLAGS_ENABLED": ["donations", "listingPromptAvailability", "listingPromptEstimatedPrice", "listMembers", "loanFee", "measureImpact", "popularItemsByTags", "predictions", "predictions", "promptSharerType", "publishListings", "rateAfterLoans", "searchListingsByUserName", "showRecommendedForYou", "similarListings", "useNewOnboarding", "viewSubscription", "conciergerie", "useActivitySector", "transactionMode", "perishableListings", "helpToTransport", "interestAlerts"]
}
